import { useEffect, useState } from 'react'

export function useVersionCheck () {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/meta.json', { cache: 'no-store' })
        const data = await res.json()
        if (data.version && data.version !== __APP_VERSION__) {
          setUpdateAvailable(true)
        }
      } catch (err) {
        console.error('Error checking version:', err)
      }
    }

    const interval = setInterval(checkVersion, 30000) // cada 30 segundos
    checkVersion() // primera vez

    return () => clearInterval(interval)
  }, [])

  return updateAvailable
}
